import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ElioButtonComponent } from '@elio/emanager-front/shared/ui/button';
import { ElioModalComponent } from '@elio/emanager-front/shared/ui/modal';
import { ElioSvgIconsModule } from '@elio/shared/icon-utils';
import { TRANSLOCO_SCOPE, TranslocoModule } from '@ngneat/transloco';
import { Locale, scopeLoader } from 'scoped-translations';
import { CookieConsentStore } from './cookie-consent.store';

@Component({
  selector: 'elio-cookie-consent',
  templateUrl: './cookie-consent.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ElioButtonComponent,
    TranslocoModule,
    RouterModule,
    ElioModalComponent,
    ElioSvgIconsModule,
  ],
  styles: [
    `
      .toggle-dot {
        top: -0.25rem;
        left: -0.25rem;
        transition: all 0.3s ease-in-out;
      }

      input:checked ~ .toggle-dot {
        transform: translateX(100%);
        @apply bg-blue;
      }
    `,
  ],
  providers: [
    {
      provide: TRANSLOCO_SCOPE,
      useValue: {
        scope: 'cookieConsent',
        loader: scopeLoader(
          (lang: Locale, root: string) => import(`libs/emanager-front/cookie-consent/${root}/${lang}.json`)
        ),
      },
    },
  ],
})
export class CookieConsentComponent {
  constructor(private cookieConsentStore: CookieConsentStore) {}

  isDetailOpen = false;

  isGoogleAnalytics = this.cookieConsentStore.isCookieAccepted('Google Analytics');

  validate() {
    this.cookieConsentStore.setCookie({ cookieType: 'Google Analytics', accept: this.isGoogleAnalytics });
    this.cookieConsentStore.setDisplay(false);
  }

  acceptAll() {
    this.cookieConsentStore.acceptAllCookies();
  }

  denyAll() {
    this.cookieConsentStore.refuseAllCookies();
  }

  cancel() {
    this.cookieConsentStore.setDisplay(false);
  }
}
